export enum DataProductPageRoutes {
  OVERVIEW_ROUTE = '',
  DATA_CONTRACTS_LINEAGE = '/data-contracts',
  REVIEWS_ROUTE = '/reviews',
  RELATIONS_ROUTE = '/dependencies',
  QUESTIONS_ROUTE = '/questions',
  OBSERVABILITY_ROUTE = '/observability',
  CONTROL_CENTER = '/control-center',
}
